import { AnalyticsPlatforms, useAnalytics } from '@dni-analysis'
import { Text } from '@pets-ui/Text/Text'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useContextCosign } from '../useContextCosign'
import { LoginLink } from './LoginLink'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  serviceContainer: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    position: {
      [MOBILE]: 'absolute',
      default: 'relative',
    },
    transform: 'translateX(-50%)',
    bottom: {
      [MOBILE]: '20px',
      default: '0px',
    },
    left: '50%',
    marginTop: {
      [MOBILE]: '0px',
      default: '20px',
    },
    width: '100%',
  },
})

export function Service() {
  const { serverLink } = useContextCosign()
  const { t } = useTranslation()
  const { sendEvent } = useAnalytics({ defaultPlatforms: [AnalyticsPlatforms.GA4] })

  const handleClickContactUs = () => {
    sendEvent({ eventName: 'Email OTP cs', eventParams: { event_category: 'Email OTP' } })
  }

  return (
    <div {...stylex.props(styles.serviceContainer)}>
      <Text variant="caption" color={colors.grey700}>{t('login.questionsContact')}</Text>
      <LoginLink href={serverLink} onClick={handleClickContactUs}>
        &nbsp;
        {t('login.customerService')}
      </LoginLink>
    </div>
  )
}
